// Currencies now come from the admin-managed list (see GET_ACTIVE_CURRENCIES /
// api/scripts/seed-currencies.js) instead of a static array here.

export const paymentMethods = [
  {
    id: "SEPA",
    name: "SEPA",
    icon: {
      light: "./spea-black.svg",
      dark: "./spea-white.svg",
    },
  },
  {
    id: "BANK",
    name: "Open Banking",
    icon: {
      light: "./openbank-black.svg",
      dark: "./openbank-white.svg",
    },
  },
  {
    id: "CARD",
    name: "VISA",
    icon: {
      light: "./visa-black.svg",
      dark: "./visa-white.svg",
    },
  },
  {
    id: "GOOGLE_PAY",
    name: "Google Pay",
    icon: {
      light: "./gpay-black.svg",
      dark: "./gpay-white.svg",
    },
  },
  {
    id: "APPLE_PAY",
    name: "Apple Pay",
    icon: {
      light: "./apple-pay-black.svg",
      dark: "./apple-pay-white.svg",
    },
  },
  {
    id: "OTHERS",
    name: "Others",
    icon: {
      light: "./others-black.svg",
      dark: "./others-white.svg",
    },
  },
];


// All major cryptocurrencies
export const cryptoCurrencies = [
  { code: "ETH", name: "Ethereum", icon: "Ξ", network: "ethereum", price: 2280.75 },
  { code: "BTC", name: "Bitcoin", icon: "₿", network: "mainnet", price: 43250.50 },
  // { code: "SOL", name: "Solana", icon: "◎", network: "solana", price: 98.65 },
  // { code: "USDT", name: "Tether", icon: "₮", network: "ethereum", price: 1.00 },
  // { code: "USDC", name: "USD Coin", icon: "$", network: "ethereum", price: 1.00 },
  // { code: "BNB", name: "Binance Coin", icon: "◈", network: "bsc", price: 312.40 },
  // { code: "USDT", name: "Tether", icon: "₮", network: "tron", price: 1.00 },
  // { code: "USDT", name: "Tether", icon: "₮", network: "bsc", price: 1.00 },
  // { code: "MUSD", name: "MetaMask USD", icon: "$", network: "ethereum", price: 1.00 },
  // { code: "LTC", name: "Litecoin", icon: "Ł", network: "mainnet", price: 72.15 },
  // { code: "XRP", name: "XRP", icon: "✕", network: "mainnet", price: 0.62 },
  // { code: "USDT", name: "Tether", icon: "₮", network: "polygon", price: 1.00 },
  // { code: "USDC", name: "USD Coin", icon: "$", network: "stellar", price: 1.00 },
  // { code: "USDC", name: "USD Coin", icon: "$", network: "polygon", price: 1.00 },
  // { code: "USDC", name: "USD Coin", icon: "$", network: "bsc", price: 1.00 },
  // { code: "TRX", name: "TRON", icon: "◊", network: "mainnet", price: 0.11 },
  // { code: "TON", name: "Toncoin", icon: "◉", network: "ton", price: 5.25 },
  // { code: "USDC", name: "USD Coin", icon: "$", network: "solana", price: 1.00 },
  // { code: "USDC", name: "USD Coin", icon: "$", network: "base", price: 1.00 },
  // { code: "ETH", name: "Ethereum", icon: "Ξ", network: "base", price: 2280.75 }
];


export const mockMerchants = [
  {
    id: "merchant-1",
    name: "CryptoTrust Pro",
    rating: 4.9,
    completedTrades: 1250,
    bankName: "HDFC Bank",
    accountNumber: "1234567890123456",
    accountName: "CryptoTrust Solutions Pvt Ltd",
    ifscCode: "HDFC0001234",
  },
  {
    id: "merchant-2",
    name: "FastCrypto Exchange",
    rating: 4.8,
    completedTrades: 890,
    bankName: "ICICI Bank",
    accountNumber: "9876543210987654",
    accountName: "FastCrypto Trading LLC",
    ifscCode: "ICIC0005678",
  },
  {
    id: "merchant-3",
    name: "SecureSwap",
    rating: 4.7,
    completedTrades: 2100,
    bankName: "State Bank of India",
    accountNumber: "5555666677778888",
    accountName: "SecureSwap International",
    ifscCode: "SBIN0009012",
  },
];

export const getRandomMerchant = () => {
  const randomIndex = Math.floor(Math.random() * mockMerchants.length);
  return mockMerchants[randomIndex];
};

export const generateTxHash = () => {
  const chars = "0123456789abcdef";
  let hash = "0x";
  for (let i = 0; i < 64; i++) {
    hash += chars[Math.floor(Math.random() * chars.length)];
  }
  return hash;
};

export const calculateCryptoAmount = (fiatAmount, cryptoPrice) => {
  if (isNaN(fiatAmount) || fiatAmount <= 0) return 0;
  return fiatAmount / cryptoPrice;
};

// Wallet address validation patterns
export const walletPatterns = {
  BTC: /^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,62}$/,
  ETH: /^0x[a-fA-F0-9]{40}$/,
  USDT: /^(0x[a-fA-F0-9]{40}|T[a-zA-Z0-9]{33})$/,
  BNB: /^(0x[a-fA-F0-9]{40}|bnb[a-zA-Z0-9]{38})$/,
  SOL: /^[1-9A-HJ-NP-Za-km-z]{32,44}$/,
  XRP: /^r[0-9a-zA-Z]{24,34}$/,
  USDC: /^0x[a-fA-F0-9]{40}$/,
  ADA: /^addr1[a-z0-9]{58}$/,
  DOGE: /^D[5-9A-HJ-NP-U][1-9A-HJ-NP-Za-km-z]{32}$/,
  TRX: /^T[a-zA-Z0-9]{33}$/,
  DOT: /^1[a-zA-Z0-9]{47}$/,
  MATIC: /^0x[a-fA-F0-9]{40}$/,
  LINK: /^0x[a-fA-F0-9]{40}$/,
  AVAX: /^(0x[a-fA-F0-9]{40}|X-avax[a-zA-Z0-9]{39})$/,
  SHIB: /^0x[a-fA-F0-9]{40}$/,
  LTC: /^[LM3][a-km-zA-HJ-NP-Z1-9]{26,33}$/,
  BCH: /^(bitcoincash:)?[qp][a-z0-9]{41}$/,
  ATOM: /^cosmos[a-z0-9]{38,45}$/,
  UNI: /^0x[a-fA-F0-9]{40}$/,
  XLM: /^G[A-Z2-7]{55}$/,
  ETC: /^0x[a-fA-F0-9]{40}$/,
  FIL: /^f[0-3][a-z0-9]{39,}$/,
  APT: /^0x[a-fA-F0-9]{64}$/,
  NEAR: /^[a-z0-9_-]{2,64}(\.near)?$/,
  ARB: /^0x[a-fA-F0-9]{40}$/,
  OP: /^0x[a-fA-F0-9]{40}$/,
  INJ: /^inj[a-z0-9]{38}$/,
  ALGO: /^[A-Z2-7]{58}$/,
  VET: /^0x[a-fA-F0-9]{40}$/,
  SAND: /^0x[a-fA-F0-9]{40}$/,
};

export const validateWalletAddress = (address, cryptoCode) => {
  const pattern = walletPatterns[cryptoCode];
  if (!pattern) return true; // Allow if no pattern defined
  return pattern.test(address);
};
